<app-modal-dialog #modal
    title="{{ 'orderDetails.orderDetails' | translate }}"    
    [hasCancel]="false"
    [hasClose]="true" 
    [hasOk]="false"    
    [static]="true"
    (onClose)="onClose()"
    class="modal-lg"    
    modalId="orderDetailsModal">
    <div class="form-col" *ngIf="order">
        <table class="table table-hover table-bordered">
            <tbody>
                <tr *ngFor="let line of order.orderLines">
                    <td>
                        <span class="order-item">{{getProductTitle(line)}}</span>
                        <span class="order-quantity">x{{line.quantity}}</span>
                        <p class="order-notes"><i>{{line.notes}}</i></p>
                    
                        <td class="price-cell" >{{line.totalPrice | currency:'EUR'}}</td>
                </tr>
            </tbody>
            <tfoot>
                <tr>
                    <td>
                        <span class="order-total">
                            {{ 'orderDetails.total' | translate }}
                        </span>
                    </td>
                    <td class="order-total price-cell">{{order.totalCost | currency:'EUR'}}</td>
                </tr>
            </tfoot>
        </table>
        <hr/>
        <p>{{ 'orderDetails.orderNumber' | translate }}: <b>{{order.uiId}}</b></p>
    </div>
</app-modal-dialog>